import { useSelector } from 'react-redux';

export default function useIframeLogo() {
  const mentors = useSelector((state) => state.mentors);
  return mentors?.mentor?.settings?.profile_image ?? '/images/logo-iframe.gif';
}
